import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import UserProfilePhoto from 'dpl/components/UserProfilePhoto';
import Icon from 'dpl/common/components/Icon';


export default function UserHeaderLoggedInDropdownHeading({
  slim, name, user, hasNotifications, isOpen
}) {
  const profilePhotoDiameter = slim ? '32px' : '40px';

  return (
    <div className="flex items-center justify-end">
      <span
        className={
          classnames('UserHeaderLoggedInDropdown__name flex-auto tr truncate fw-medium', {
            'mr3 mid-gray d-none d-xl-block': !slim,
            'mr4 white f2': slim
          })
        }
      >
        { name }
      </span>
      <span className={ classnames('f0 fw-light br-100', { 'bw1 ba b--near-white': slim, mr1: !slim }) }>
        <div className="relative">
          <div className="relative br-100 overflow-hidden">
            <UserProfilePhoto
              diameter={ profilePhotoDiameter }
              user={ user }
              forceColor="#E54563"
            />
            <div className="hover-bg-black transition absolute absolute--fill o-20" />
          </div>
          { hasNotifications && (
            <span className="pv1 ph1 bg-red db absolute ba bw1 b--white br-100 right-0 top-0" />
          ) }
        </div>
      </span>
      { !slim && <Icon className="mid-gray" name={ `fat-arrow-${isOpen ? 'up' : 'down'}` } /> }
    </div>
  );
}

UserHeaderLoggedInDropdownHeading.propTypes = {
  slim: PropTypes.bool,
  name: PropTypes.string.isRequired,
  user: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    initials: PropTypes.string,
    profile_photo_url: PropTypes.string
  }).isRequired,
  hasNotifications: PropTypes.bool.isRequired,
  isOpen: PropTypes.bool.isRequired
};

UserHeaderLoggedInDropdownHeading.defaultProps = {
  slim: false
};
